import React from "react";
import PropTypes from "prop-types";

import MerchantLogo from "@/components/atoms/MerchantLogo";
import { useTransactionData } from "@/context/transactionContext";
import { ReactComponent as Clock } from "@/assets/images/yellow_clock.svg";
import i18n from "@/translate/i18n";

import { LogoWrapper, CriptenLogo } from "./styles";

function Header({ time, transactionData: dataFromProps, methodLabel }) {
  const { transactionData: dataFromContext } = useTransactionData();
  const transactionData = dataFromProps || dataFromContext;

  const shouldRenderLogo = !transactionData?.merchant?.checkout_hide_brand;

  return (
    <div className="flex items-center justify-center w-full relative bg-cripten-dark h-16">
      {shouldRenderLogo && (
        <>
          <MerchantLogo
            slug={transactionData?.merchant?.slug}
            name={transactionData?.merchant?.name}
            height="13px"
          />
          <LogoWrapper>
            <CriptenLogo />
            <p className="leading-3">
              {methodLabel || i18n.t("general.bankTransfer")}
            </p>
          </LogoWrapper>
        </>
      )}
      {time && (
        <div className="flex items-center gap-1 absolute right-5 text-cripten-primary">
          <Clock />
          {time}
        </div>
      )}
    </div>
  );
}

Header.propTypes = {
  time: PropTypes.string,
  methodLabel: PropTypes.string,
  transactionData: PropTypes.shape({
    merchant: PropTypes.shape({
      slug: PropTypes.string,
      name: PropTypes.string,
      checkout_hide_brand: PropTypes.bool,
    }),
  }),
};

Header.defaultProps = {
  time: null,
  methodLabel: null,
  transactionData: null,
};

export default Header;
